import { NgModule } from '@angular/core';
import { TextOverflowPipe } from './text-overflow.pipe';
@NgModule({
    declarations: [TextOverflowPipe],
    exports: [TextOverflowPipe]
})
export class TextOverflowModule { }
